exports = module.exports = require("../../../../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "._2IxGfkfj5Xt9Kx6mKm71mH{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:horizontal;-webkit-box-direction:normal;-ms-flex-direction:row;flex-direction:row;-webkit-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between}.i8ACHOhwm4L2hjAwQD_jB{-webkit-box-pack:end;-ms-flex-pack:end;justify-content:flex-end}", ""]);

// exports
exports.locals = {
	"premiumSupportContainer": "_2IxGfkfj5Xt9Kx6mKm71mH",
	"premiumSuupport_btn_container": "i8ACHOhwm4L2hjAwQD_jB"
};